import type { PersonResult } from '../types';

type Props = {
  person: PersonResult;
};

function titleSegments(raw?: string): string[] {
  if (!raw?.trim()) return [];
  return raw
    .split(/[;]/)
    .map((s) => s.trim())
    .filter(Boolean);
}

export default function PeopleCard({ person }: Props) {
  const image = `//uws.njit.edu/ldapimage.php?format=full&uid=${encodeURIComponent(person.ucid)}`;
  const profileUrl = `//people.njit.edu/profile/${encodeURIComponent(person.ucid)}`;
  const segments = titleSegments(person.title);
  var deptLine = person.department?.title?.trim();
  const showTitles = segments.length > 0 || Boolean(deptLine);

  if (deptLine == 'faculty_staff_missing_org') {
    deptLine = deptLine.replace(/_/g, ' ');
  }

  return (
    <li className="person col-12 col-md-12 col-lg-6">
      <a href={profileUrl}>
        <div className="image-container">
          <img src={image} alt={`Photo of ${person.display_name}`} loading="lazy" />
        </div>
        <div className="text-container">
          <div className="name">{person.display_name}</div>
          {showTitles ? (
            <ul className="title-container list-unstyled">
              {segments.map((line) => (
                <li key={line} className="title">
                  {line}
                </li>
              ))}
              {deptLine ? <li className="title">{deptLine}</li> : null}
            </ul>
          ) : null}
          <span className="button text">View Profile</span>
        </div>
      </a>
    </li>
  );
}
